import React from 'react';

import { Chart } from '../Chart';


export type DataItem = {
  name: string
  y: number
}


export type DonutProps = {
  seriesName?: string,
  title: string,
  data: DataItem[],
  hideLegend?: boolean,
};

export function Donut(props: DonutProps) {
  return <Chart
    title={props.title}
    config={{
      credits: {enabled: false},
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: !props.hideLegend,
        }
      },
      series: [{
        type: 'pie',
        name: props.seriesName || props.title,
        innerSize: '50%',
        data: props.data,
      }]
    }}
  />
}